export const readFile = (file) => {
  return new Promise((resolve, reject) => {
    try {
      var reader = new FileReader();

      reader.onload = (e) => resolve(e.currentTarget.result);
      reader.onabort = (e) => reject(e);
      reader.onerror = (e) => reject(e);

      reader.readAsDataURL(file);
    } catch (error) {
      reject(error);
    }
  });
};

export const fileToObj = (file) => {
  return {
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
    name: file.name,
    preview: file.preview,
    size: file.size,
    type: file.type,
    webkitRelativePath: file.webkitRelativePath,
  };
};

export const downloadPdf = (blob, filename) => {
  const newBlob = new Blob([blob], { type: 'application/pdf' });
  const data = window.URL.createObjectURL(newBlob);
  const link = document.createElement('a');

  link.href = data;
  link.download = `${filename}.pdf`;
  link.click();
};
